import { render, staticRenderFns } from "./BussinessStep4.vue?vue&type=template&id=3a022f6a&"
import script from "./BussinessStep4.vue?vue&type=script&lang=js&"
export * from "./BussinessStep4.vue?vue&type=script&lang=js&"
import style0 from "./BussinessStep4.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports